import type { OptionType } from '@tools/types/common.types.ts';
import type { CountryDataType } from '@eshop/types/location.types.ts';

export interface CountryDTO {
  iso_3166_1_a2: string;
  printable_name: string;
}

export interface StateDTO {
  id_region1: number;
  codigo31662: string;
  nombre: string;
}

export interface CityDTO {
  code: string;
  label: string;
}

export interface PostcodeDTO {
  id_localidad: number;
  codigo_postal: number | string;
  cp_codigo31662?: string | null;
  nombre: string;
}

export const mapCountries = (data: CountryDTO[]): CountryDataType[] =>
  data.map(c => ({ iso_3166_1_a2: c.iso_3166_1_a2, printable_name: c.printable_name }));

export const mapStatesToOptions = (data: StateDTO[]): OptionType[] =>
  data.map(s => ({ label: s.nombre, value: s.codigo31662 }));

export const mapCitiesToOptions = (data: CityDTO[]): OptionType[] =>
  data.map(c => ({ label: c.label, value: c.code }));

export const mapPostcodesToOptions = (data: PostcodeDTO[]): OptionType[] =>
  data.map(p => ({ label: String(p.codigo_postal), value: p.codigo_postal }));
